
    import './styles.scoped.css';
    export default {
  "arrow": "awsui_arrow_1hpp3_yi9t5_99",
  "arrow-outer": "awsui_arrow-outer_1hpp3_yi9t5_103",
  "arrow-inner": "awsui_arrow-inner_1hpp3_yi9t5_103",
  "arrow-position-right-top": "awsui_arrow-position-right-top_1hpp3_yi9t5_144",
  "arrow-position-right-bottom": "awsui_arrow-position-right-bottom_1hpp3_yi9t5_144",
  "arrow-position-left-top": "awsui_arrow-position-left-top_1hpp3_yi9t5_147",
  "arrow-position-left-bottom": "awsui_arrow-position-left-bottom_1hpp3_yi9t5_147",
  "arrow-position-top-center": "awsui_arrow-position-top-center_1hpp3_yi9t5_150",
  "arrow-position-top-responsive": "awsui_arrow-position-top-responsive_1hpp3_yi9t5_150",
  "arrow-position-bottom-center": "awsui_arrow-position-bottom-center_1hpp3_yi9t5_153",
  "arrow-position-bottom-responsive": "awsui_arrow-position-bottom-responsive_1hpp3_yi9t5_153",
  "annotation": "awsui_annotation_1hpp3_yi9t5_161",
  "next-button": "awsui_next-button_1hpp3_yi9t5_162",
  "previous-button": "awsui_previous-button_1hpp3_yi9t5_163",
  "finish-button": "awsui_finish-button_1hpp3_yi9t5_164",
  "header": "awsui_header_1hpp3_yi9t5_165",
  "step-counter-content": "awsui_step-counter-content_1hpp3_yi9t5_166",
  "content": "awsui_content_1hpp3_yi9t5_167",
  "description": "awsui_description_1hpp3_yi9t5_171",
  "actionBar": "awsui_actionBar_1hpp3_yi9t5_176",
  "stepCounter": "awsui_stepCounter_1hpp3_yi9t5_183",
  "divider": "awsui_divider_1hpp3_yi9t5_187",
  "hotspot": "awsui_hotspot_1hpp3_yi9t5_191",
  "icon": "awsui_icon_1hpp3_yi9t5_258"
};
  